/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {
  saveJob,
  unFollowJob,
  unFollowRecruiter,
} from '@jobseeker/common-core/reducers/job/thunkServices/jobfeed';
import JobFeedV2 from '@jobseeker/feature-job/components/JobFeed/V2';
import surveyService from '@jobseeker/common-core/services/survey.service';
import {useEffect, useState} from 'react';
import {SurveyQuestionType} from '@jobseeker/feature-ads/components/Survey/types';
import {Survey as SurveyType} from '@jobseeker/common-core/services/types';
import {handleTracking} from '@jobseeker/common-core/utils';
import moment from 'moment';
import JobsJsonLd from '@jobseeker/feature-job/components/JobItemListingSchema';

import type {AppState} from '@jobseeker/common-core/types';
import type {AdElement} from '@jobseeker/feature-ads/components/AdsBanner/types';

type Fn = () => any;
type JobFeedsListViewProps = {
  routeToJobDetail: (jobSlug: string, jobId: string | number) => void;
  onLoadMore: Fn;
  jobInfoKeyElements: any;
  feedOnly: boolean;
  title: string;
  showThreeDotMenu?: boolean;
  onFilter?: (filterData: any) => void;
  onClearFilter?: () => void;
  onInfiniteScroll?: () => void;
  learnGrow?: AdElement;
  variant?: string;
  injectAsChild?: boolean;
  onFilterChange?: (filterData: object) => void;
  onJobSave?: (data: object) => void;
  showApplied?: boolean;
  catId?: string | number;
  checkJobs?: number[];
  cityJobs?: any;
  preFilters?: {
    page: number;
  } & Record<string, any>;
  extractedParams?: any;
};
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

const JobFeedsListV2 = ({
  routeToJobDetail,
  onLoadMore,
  jobInfoKeyElements,
  feedOnly,
  title,
  onFilter,
  onInfiniteScroll,
  onClearFilter,
  variant,
  onFilterChange,
  extractedParams,
  preFilters,
  ...props
}: JobFeedsListViewProps) => {
  const dispatch = useDispatch<any>();

  const {isLoggedIn, userId} = useSelector((state: AppState) => state.auth);
  const tags = useSelector((state: AppState) => state.user?.profile?.tags);

  const jobFeedStore = useSelector((state: AppState) => state.job);

  const page = useSelector((state: AppState) => state.app.page, shallowEqual);
  const hideFilter = !tags?.length && page === 'jobfeed' ? true : feedOnly;

  const onJobSave = (jobData: any, unsave: boolean) => {
    if (isLoggedIn) {
      dispatch(
        saveJob({
          ...jobData,
          jobId: jobData.id,
          unsave,
          userId: userId,
        })
      );
    }
    props.onJobSave &&
      props.onJobSave({
        ...jobData,
        jobId: jobData.id,
        unsave,
        userId: userId,
      });
  };

  const onJobActionClick = (jobId: string, action: string) => {
    if (action == 'JOB') {
      dispatch(
        unFollowJob({
          undo: false,
          jobId: jobId,
          userId: userId,
        })
      );
    } else {
      dispatch(
        unFollowRecruiter({
          undo: false,
          recruiterId: 'NO_REC_ID',
          userId: userId,
        })
      );
    }
  };

  const onUndoActionClick = (jobId: string, action: string) => {
    if (action == 'JOB') {
      dispatch(
        unFollowJob({
          undo: true,
          jobId: jobId,
          userId: userId,
        })
      );
    } else {
      dispatch(
        unFollowRecruiter({
          undo: true,
          recruiterId: 'NO_REC_ID',
          userId: userId,
        })
      );
    }
  };

  const [showSurvey, setShowSurvey] = useState(false);
  const [surveyQuestions, setSurveyQuestions] = useState<SurveyQuestionType[]>(
    []
  );
  const [currQuestion, setCurrQuestion] = useState<SurveyQuestionType>(
    surveyQuestions[0]
  );
  const fetchSurveys = async () => {
    const surveys: SurveyType[] = await surveyService.getSurvey('JF');
    if (surveys?.length) {
      const jobFeedSurvey = surveys.find(
        survey => survey?.type === 'RelevantJob'
      );
      if (jobFeedSurvey) {
        setShowSurvey(true);
        handleTracking('jsViewRelevantJobSurvey', {
          event_category: 'Job_recommedation_survey',
          UserId: sessionStorage.getItem('userId') || 'NA',
          Device: sessionStorage.getItem('device') || 'desktop',
          Device_Type: sessionStorage.getItem('deviceType') || 'web',
          Status: sessionStorage.getItem('status') || 'LoggedOut',
          Origin: page,
          Date: moment().format('DD/MM/YYYY'),
        });
        setSurveyQuestions(jobFeedSurvey?.questions);
        setCurrQuestion(jobFeedSurvey?.questions[0]);
      }
    }
  };

  useEffect(() => {
    if (page === 'jobfeed') {
      fetchSurveys();
    }
  }, [page]);

  // const JobFeedComponent =
  //   process.env.NEXT_PUBLIC_APP_NAME === 'hirist' ? JobFeedHirist : JobFeedV2;

  // console.log(
  //   process.env.NEXT_PUBLIC_APP_NAME,
  //   'JobFeedHirist',
  //   JobFeedComponent
  // );

  return (
    <>
      {!props?.injectAsChild && (
        <JobsJsonLd
          name={`${title}`}
          jobs={[
            ...jobFeedStore?.jobfeed,
            ...(page === 'location_based' &&
            props?.cityJobs?.jobs?.length > 0 &&
            jobFeedStore?.jobfeed?.length < 20 &&
            !isAppIimjobs
              ? props?.cityJobs?.jobs
              : []),
          ]}
        />
      )}
      <JobFeedV2
        onLoadMore={onLoadMore}
        onUndoActionClick={onUndoActionClick}
        onJobActionClick={onJobActionClick}
        onFilter={onFilter}
        onClearFilter={onClearFilter}
        feedOnly={feedOnly}
        title={title}
        variant={isLoggedIn ? 'userFeed' : ''}
        jobFeedStore={jobFeedStore}
        jobInfoKeyElements={jobInfoKeyElements}
        routeToJobDetail={routeToJobDetail}
        showSurvey={showSurvey}
        surveyQuestions={surveyQuestions}
        setShowSurvey={setShowSurvey}
        currQuestion={currQuestion}
        setCurrentQuestion={setCurrQuestion}
        page={page}
        onInfiniteScroll={onInfiniteScroll}
        onFilterChange={onFilterChange}
        {...props}
        onJobSave={onJobSave}
        showFilter={!hideFilter}
        showApplied={props.showApplied || false}
        preFilters={preFilters}
        extractedParams={extractedParams}
      />
    </>
  );
};

export default JobFeedsListV2;
